import { render, staticRenderFns } from "./Calculadora-datos.vue?vue&type=template&id=0306d10e&scoped=true&lang=html&"
import script from "./Calculadora-datos.vue?vue&type=script&lang=js&"
export * from "./Calculadora-datos.vue?vue&type=script&lang=js&"
import style0 from "./Calculadora-datos.vue?vue&type=style&index=0&id=0306d10e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0306d10e",
  null
  
)

export default component.exports